import React from 'react';

const TextWaterfall: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const getJustification = (nodeIndex: number): 'end' | 'center' | 'start' => {
    // this sequence is only designed to work with responsibility image in course 8
    const justifications = ['center', 'start', 'end', 'center'] as const;
    const index = nodeIndex % justifications.length;
    return justifications[index];
  };

  return (
    <>
      {React.Children.map(children, (child, index) => {
        if (!React.isValidElement(child)) {
          return child;
        }
        const childStyle = child.props?.style;
        const styles = typeof childStyle === 'object' ? { ...childStyle } : {};
        styles.justifyContent = getJustification(index);
        return React.cloneElement(
          child as React.ReactElement<{ style?: React.CSSProperties }>,
          {
            key: child?.toString() || index,
            style: styles,
          },
        );
      })}
    </>
  );
};

export default TextWaterfall;
